<template>
  <div
    class="flex items-center gap-1 leading-[18px] shrink-0 font-medium"
    :class="expired ? 'fg-error-primary' : 'text-utility-gray-500'"
  >
    <template v-if="date">
      <template v-if="icon">
        <Icon
          v-if="task.status == 'completed'"
          name="calendar-check"
          size="sm"
          class="-mt-px"
        />
        <Icon
          v-if="task.status !== 'completed'"
          name="calendar-default"
          size="sm"
          class="-mt-px"
        />
      </template>
      <span>
        {{ date }}
      </span>
    </template>
    <div v-else class="text-utility-gray-300">
      {{ t("components.task.no_date") }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Icon } from "@/SharedComponents/Icon";
import { formatDate } from "@/Utils/date";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  expired: { type: Boolean, required: true },
  task: { type: Object, required: true },
  icon: { type: Boolean, required: true },
});

const date = computed(() => {
  if (props.task.completed_at) {
    return formatDate(props.task.completed_at);
  }

  if (props.task.scheduled_for) {
    return formatDate(props.task.scheduled_for);
  }

  return "";
});
</script>
